<div class="file-container warning" *ngIf="loadingGeneratedFile">
	<div class="text name">Generating PDF</div>
	<div class="text name ellipsis-animate"></div>
	<button class="btn btn-primary btn-md" (click)="cancelFileGeneration()">Cancel</button>
</div>
<div class="file-container" [ngClass]="{'active': showDragDropBorder, 'hidden': uploadedDoc || (useGeneratedFile && !cancelGeneratedFile) || loadingGeneratedFile }" dragDrop (filesDropped)="fileUploaded($event)" (filesDraggedOver)="showDragDropBorder = true" (filesDraggedLeave)="showDragDropBorder = false">
	<label for="file">
		<div class="text text-no-margin">Drag and drop file here</div>
		<div class="text text-no-margin">or</div>
		<div class="btn btn-primary btn-md button btn-browse"><i class="fas fa-file"></i> Browse for file</div>
		<button *ngIf="generatedFileExists" class="btn btn-primary btn-md button btn-use" (click)="selectUseGeneratedPDF()">Use generated PDF</button>
	</label>
	<input class="file-input" type="file" id="file" (change)="fileUploaded($event)">
</div>
<div class="file-container success" [ngClass]="{'hidden': !uploadedDoc || loadingGeneratedFile }">
	<div class="text name">{{ uploadedDoc?.name }}</div>
	<button class="btn btn-primary btn-md" (click)="fileCleared()">Clear file</button>
</div>
<div class="file-container success" [ngClass]="{'hidden': !useGeneratedFile || loadingGeneratedFile || cancelGeneratedFile }">
	<div class="text name">Generated PDF</div>
	<div class="text name"><i class="fas fa-file-pdf"></i></div>
	<button class="btn btn-primary btn-md" (click)="fileCleared()">Clear file</button>
</div>